import React from "react";
import backgroundLandingImg from "../../../../assets/background-landing.png";

const PrintMaterialNavHeader = () => {
  return (
    <section
      className="relative w-full bg-[#6E3FC6] bg-cover bg-center bg-no-repeat py-20 md:py-24 px-6 text-center font-[Lexend] mt-8 sm:mt-10 md:mt-14 min-h-[280px]"
      style={{ backgroundImage: `url(${backgroundLandingImg})` }}
    >
      {/* Background Overlay */}
      <div className="absolute inset-0 bg-[#6E3FC6]/65 pointer-events-none"></div>

      {/* Content */}
      <div className="relative max-w-[720px] mx-auto pt-[50px] h-[120px] mt-[-3rem]"> {/* 👈 Added top padding */}
        <h1 className="font-semibold text-[26px] sm:text-[24px] md:text-[42px] lg:text-[48px] lowercase leading-[50px] text-white mb-[12px]">
          printing material
        </h1>

        {/* <p className="font-[Lexend] font-normal text-[15px] md:text-[19px] leading-[30px] sm:leading-[24px] tracking-normal text-white text-center lowercase mt-[11px] max-w-[700px] mx-auto"> */}
          <p className="mt-4 text-[#e0dfff] text-base md:text-lg font-normal max-w-[600px] mx-auto">
          use our print materials & qr codes so your customers can download be<span className="inline-block scale-x-[-1]">e</span>mz & engage with you.
        </p>
      </div>
    </section>
  );
};

export default PrintMaterialNavHeader;
